// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_login_modal_send_email_link = /** @type {(inputs: {}) => string} */ () => {
	return `Email Sent. Please Check Your Inbox.`
};

const id_login_modal_send_email_link = /** @type {(inputs: {}) => string} */ () => {
	return `Email Dikirim. Silakan Periksa Kotak Masuk Anda.`
};

const de_login_modal_send_email_link = /** @type {(inputs: {}) => string} */ () => {
	return `E-Mail gesendet. Bitte prüfen Sie Ihren Posteingang.`
};

const fr_login_modal_send_email_link = /** @type {(inputs: {}) => string} */ () => {
	return `Courriel envoyé. Veuillez consulter votre boîte de réception.`
};

const es_login_modal_send_email_link = /** @type {(inputs: {}) => string} */ () => {
	return `Correo electrónico enviado. Por favor revise su bandeja de entrada.`
};

const ru_login_modal_send_email_link = /** @type {(inputs: {}) => string} */ () => {
	return `Письмо отправлено. Проверьте, пожалуйста, свой почтовый ящик.`
};

const zh_login_modal_send_email_link = /** @type {(inputs: {}) => string} */ () => {
	return `验证邮件已发送，请去往邮箱点击链接登录`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "de" | "fr" | "es" | "ru" | "zh" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const login_modal_send_email_link = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_modal_send_email_link(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_modal_send_email_link", locale)
	if (locale === "en") return en_login_modal_send_email_link(inputs)
	if (locale === "id") return id_login_modal_send_email_link(inputs)
	if (locale === "de") return de_login_modal_send_email_link(inputs)
	if (locale === "fr") return fr_login_modal_send_email_link(inputs)
	if (locale === "es") return es_login_modal_send_email_link(inputs)
	if (locale === "ru") return ru_login_modal_send_email_link(inputs)
	if (locale === "zh") return zh_login_modal_send_email_link(inputs)
	return "login_modal_send_email_link"
};